import type { DashboardTone } from "../types/dashboard.types";

interface AvatarBadgeProps {
	initials: string;
	tone?: DashboardTone;
}

export function AvatarBadge({ initials, tone = "blue" }: AvatarBadgeProps) {
	return <span className={`crm-mini-avatar ${tone}`}>{initials}</span>;
}
